// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-message-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

  > * {
    pointer-events: auto;
  }
}

#app-root.options-dialog-open .app-message-container {
  z-index: 0;
}

#app-root.start-training-dialog-open .sessionview button,
#app-root.start-training-dialog-open .sessionview button *,
#app-root.start-training-dialog-open .sessionview input,
#app-root.start-training-dialog-open .sessionview select,
#app-root.start-training-dialog-open .sessionview textarea,
#app-root.start-training-dialog-open .sessionview [role="button"] {
  pointer-events: none;
}

#app-root.start-training-dialog-open .sessionview .allow-settings-during-training-dialog,
#app-root.start-training-dialog-open .sessionview .allow-settings-during-training-dialog * {
  pointer-events: auto;
}
`, "",{"version":3,"sources":["webpack://./src/ui/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;;EAEV;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;;;EAME,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;AACtB","sourcesContent":[".app-message-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  pointer-events: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n\n  > * {\n    pointer-events: auto;\n  }\n}\n\n#app-root.options-dialog-open .app-message-container {\n  z-index: 0;\n}\n\n#app-root.start-training-dialog-open .sessionview button,\n#app-root.start-training-dialog-open .sessionview button *,\n#app-root.start-training-dialog-open .sessionview input,\n#app-root.start-training-dialog-open .sessionview select,\n#app-root.start-training-dialog-open .sessionview textarea,\n#app-root.start-training-dialog-open .sessionview [role=\"button\"] {\n  pointer-events: none;\n}\n\n#app-root.start-training-dialog-open .sessionview .allow-settings-during-training-dialog,\n#app-root.start-training-dialog-open .sessionview .allow-settings-during-training-dialog * {\n  pointer-events: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
